import apiClient from '@u/apiClient'
import GetTaskListController from '@/wayfinder/actions/App/Http/Controllers/Task/GetTaskListController'
import GetTaskByIdController from '@/wayfinder/actions/App/Http/Controllers/Task/GetTaskByIdController'
import GetTaskActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Task/GetTaskActivitiesByIdController'
import CreateTaskController from '@/wayfinder/actions/App/Http/Controllers/Task/CreateTaskController'
import UpdateTaskController from '@/wayfinder/actions/App/Http/Controllers/Task/UpdateTaskController'
import DeleteTaskController from '@/wayfinder/actions/App/Http/Controllers/Task/DeleteTaskController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import GetUsersListByFuneralHomeController from '@/wayfinder/actions/App/Http/Controllers/Task/GetUsersListByFuneralHomeController'
// import router from '@/router'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchTasksList({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetTaskListController.get())
      .then(async (response) => {
        commit('setTasksList', response.data.tasks)
        commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchTasksList', reason)
      })
  },
  async fetchTaskById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetTaskByIdController.get({ task: payload }))
      .then(async (response) => {
        commit('setTask', response.data.task)
        commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchTaskById', reason)
      })
  },
  async fetchNewTask({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'Task' } }))
      .then(async (response) => {
        await commit('setTask', response.data.Task)
        await commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewTask', reason)
      })
  },
  async fetchUsersByFuneralHomeID({ commit }, payload) {
    await apiClient
      .route(
        GetUsersListByFuneralHomeController.get(
          { funeralHome_id: payload.funeral_home_id },
          { query: { terms: payload.terms } }
        )
      )
      .then(async (response) => {
        if (payload.type === 'executors') {
          await commit('setTempExecutorUsers', {
            fh: payload.funeral_home_id,
            users: response.data.users_list
          })
        } else {
          await commit('setTempUsers', {
            fh: payload.funeral_home_id,
            users: response.data.users_list
          })
        }
      })
      .catch(async (reason) => {
        await console.error('fetchUsersByFuneralHomeID', reason)
      })
  },
  async fetchAutomationMetadata({ commit }, payload) {
    await apiClient
      .get(`/api/task/fetch-automations/${payload}`)
      .then(async (response) => {
        await commit('setTaskMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchAutomationMetadata', reason)
      })
  },
  async fetchUsersForSelect({ commit }, payload) {
    await apiClient
      .get('/api/user-for-select')
      .then(async (response) => {
        console.log(response.data)
        // if (payload.type === 'executors') {
        //   await commit('setTempExecutorUsers', {
        //     fh: payload.funeral_home_id,
        //     users: response.data.users_list
        //   })
        // } else {
        //   await commit('setTempUsers', {
        //     fh: payload.funeral_home_id,
        //     users: response.data.users_list
        //   })
        // }
      })
      .catch(async (reason) => {
        await console.error('fetchUsersByFuneralHomeID', reason)
      })
  },
  fetchTaskActivitiesByTaskID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetTaskActivitiesByIdController.get({ task: payload.task_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  async storeTask({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(CreateTaskController.post(), payload.task)
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('storeTask', reason)
      })
  },
  // endregion

  // region update
  async updateTask({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        UpdateTaskController['/api/task/{task}'].put({ task: payload.id }),
        payload.task
      )
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error(reason)
      })
  },
  // endregion

  // region delete
  async deleteTaskById({ commit }, payload) {
    await apiClient
      .route(DeleteTaskController.delete.delete({ task: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setTasksList', response.data.tasks)
          commit('setTaskMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteTaskById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteTaskById({ commit }, payload) {
    await apiClient
      .route(DeleteTaskController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          commit('setTasksList', response.data.tasks)
          commit('setTaskMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteTaskById', reason)
      })
  }
  // endregion
}
